import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import CampHeader from '../../header/CampHeader';
import CampHeaderGuest from '../../header/CampHeaderGuest';
import LoadingChallenge from './LoadingChallengeWithCreations';
import SingleChallengeCreationGallery from './SingleChallengeCreationGallery';
import SingleChallengeSubmissionHistory from './SingleChallengeSubmissionHistory';
import InfiniteScroll from 'react-infinite-scroller';
import { nextChallengeViewModel } from './next.challenge.viewmodel';
import SingleChallengeDetails from './SingleChallengeDetails';
import { useCreationHolder } from '../../context/creation/creation.holder.context';
import { actionTypes } from '../../context/creation/creation.reducer';
import { BsChevronDown } from '@react-icons/all-files/bs/BsChevronDown';
import { BsChevronUp } from '@react-icons/all-files/bs/BsChevronUp';
import LeftSideBar from '../../common/LeftSideBar';
import RightSideBar from '../../common/RightSideBar';
import './scss/next.challenge.scss';
import './scss/single.challenge.scss';
import './scss/no.submission.scss';
import PartnerHeader from '../school/PartnerHeader';
import { treehouseViewModel } from '../../common/treehouse.view.model';
import ChatInfoModal from './ChatInfoModal';
import OptimizeSignup from '../onboarding/signup_popups/OptimizeSignup';
import TimeToUpgradeModal from '../onboarding/signup_popups/TimeToUpgradeModal';

const SingleSpecialChallenge = (props) => {
  const PAGE_LIMIT = 9;
  const location = useLocation();
  const { dependent, guardian, fetchAPI, partner, school } = useAuth();
  const [rightCollapsse, setRightCollapsse] = useState("");
  const [leftCollapsse, setLeftCollapsse] = useState("");
  const myParam = new URLSearchParams(location.search).get('encrypt');
  const decryptedData = JSON.parse(atob(myParam));
  let cid = decryptedData.id;
  const [tabFlag, setTabFlag] = useState('');
  const [challengeState, setChallengeState] = useState({
    loading: true,
    repos: null,
  });
  const [currentChallenge, setCurrentChallenge] = useState({});
  const [hasSubmission, setHasSubmission] = useState(false);
  const [toggleAccepted, setToggleAccepted] = useState(false);
  const [toggleCompletedView, setToggleCompletedView] = useState(true);
  const [creationList, setCreationList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [subscribedTreehouses, setSubscribedTreehouse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(partner ? true : false)
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [showTimeToUpgradePopup, setShowTimeToUpgradePopup] = useState(false);
  const [acceptPrompt, setAcceptPrompt] = useState(false);
  // for fetch selected challenge
  const SingleChallengeDetailsWithLoader = LoadingChallenge(
    SingleChallengeDetails
  );
  // query
  const [queryCreations, setQueryCreations] = useState({
    limit: PAGE_LIMIT,
    has_more: true,
    challenge_id: cid,
  });
  const { creationHolder, dispatchCreationHolder } = useCreationHolder();

  const getSubscribedTreehouses = async () => {
    await treehouseViewModel.getSubscribedCampMasters(dependent?.id).then((res) => {
      setSubscribedTreehouse(res.map(item => item.id));
      setLoading(false);
    }).catch((err) => { });
  }

  useEffect(() => {
    if (dependent) getSubscribedTreehouses();
  }, [])

  const onUploadComplete = (challenge) => {
    setCreationList([challenge, ...creationList]);
    dispatchCreationHolder({
      type: actionTypes.ADD_CREATION,
      payload: challenge,
    });
    getChallengeDetail();
  };

  const handleDeleteCreationById = (id) => {
    setCreationList(creationList.filter((creation) => creation.id !== id));
    if (creationHolder.user.creationList === null) return;
    dispatchCreationHolder({
      type: actionTypes.DELETE_CREATION_BY_ID,
      payload: id,
    });
  };

  const getChallengeDetail = () => {
    let query = {}
    if (dependent) {
      query['dependent_id'] = dependent.id;
    }
    fetchAPI(nextChallengeViewModel.getPrivateChallengeDetails, cid, query)
      .then((response) => {
        setChallengeState({ loading: false, repos: response });
        setCurrentChallenge(response);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getChallengeDetail();
    fetchCreations();
  }, []);

  useEffect(() => {
    getChallengeDetail();
  }, [cid]);

  useEffect(() => {
    if (tabFlag === '') window.scrollTo(0, 0);
  }, [tabFlag]);

  useEffect(() => {
    setHasSubmission(
      currentChallenge.submission_count !== 0 ||
      currentChallenge.submission_count !== 0
    );
  }, [currentChallenge]);

  const fetchCreations = () => {
    setIsLoading(true);
    const previousCreationList = creationList;
    fetchAPI(
      nextChallengeViewModel.getCreations,
      queryCreations,
      previousCreationList
    )
      .then((data) => {
        ReactDOM.unstable_batchedUpdates(() => {
          // let tempFeed = data.creationList.filter((creation) => creation.admin_verified === true || !creation.admin_verified && creation.user.username === dependent.username)
          setCreationList(data.creationList);
          setQueryCreations(data.query);
        });
        setIsLoading(false);
      })
      .catch((error) => {
        // addError(error.data.message);
      });
  };

  const fetchInfiniteCreations = () => {
    if (!isLoading) fetchCreations();
  }

  const handleBinky = (creationId, binkyId, binkyCount) => {
    // update challenge's creation list
    const newFeedList = creationList.map((obj) => {
      const id = obj.creation_id ? obj.creation_id : obj.id;

      if (id === creationId)
        return {
          ...obj,
          binky_count: binkyCount,
          binky_id: binkyId,
        };
      return obj;
    });
    setCreationList(newFeedList);
  };

  const handleComment = (creationId, commentCount) => {
    const newFeedList = creationList.map((obj) => {
      const id = obj.creation_id ? obj.creation_id : obj.id;
      return (id === creationId)
        ? {
          ...obj,
          comment_count: commentCount,
        }
        : obj;
    });
    setCreationList(newFeedList);
  };

  const noSubmissionView = () => (
    <div className="single-challenge-participate">
      <section className="no-submission-section">
        {/* <div className="text">Be the first one to submit!</div> */}
        <div className="text"></div>
      </section>
    </div>
  );

  const handleToggleAcceptedDependents = () =>
    setToggleAccepted(!toggleAccepted);
  const acceptedCount = challengeState.repos
    ? challengeState.repos.accepted_dependent_count
    : 0;
  const completedCount = challengeState.repos
    ? challengeState.repos?.submission_count
    : 0;
  const acceptedTitle = `Kids currently working on this: ${acceptedCount}`;
  const completedTitle = `Kids who have completed this challenge: ${completedCount}`;
  const toggleButton = toggleAccepted ? (
    <>
      Hide <BsChevronUp />
    </>
  ) : (
    <>
      View all <BsChevronDown />
    </>
  );
  const handleToggleView = () => setToggleCompletedView(!toggleCompletedView);
  const completedView = toggleCompletedView ? (
    <InfiniteScroll
      className={`${toggleCompletedView ? '' : 'infinite-scroll-container'}`}
      pageStart={0}
      loadMore={fetchInfiniteCreations}
      hasMore={queryCreations.has_more}
      loader={<Spinner key={0} animation="border" variant="info" />}
      threshold={150}
      style={{ textAlign: 'center' }}
    >
      <SingleChallengeCreationGallery
        isGalleryView={toggleCompletedView}
        creationList={creationList}
        deleteCreationById={handleDeleteCreationById}
        handleBinky={handleBinky}
        handleComment={handleComment}
      />
    </InfiniteScroll>
  ) : (
    <div className="single-challenge-participate">
      <section className="completed-section">
        {!challengeState.loading && (
          <InfiniteScroll
            className="infinite-scroll-container"
            pageStart={0}
            loadMore={fetchInfiniteCreations}
            hasMore={queryCreations.has_more}
            loader={<Spinner key={0} animation="border" variant="info" />}
            threshold={150}
          >
            <SingleChallengeSubmissionHistory
              isGalleryView={toggleCompletedView}
              creationList={creationList}
              deleteCreationById={handleDeleteCreationById}
              handleBinky={handleBinky}
            // handleComment={handleComment}
            />
          </InfiniteScroll>
        )}
      </section>
    </div>
  );

  return (
    <div className="challenges-flex-wrapper">
      {dependent && !guardian ? (
        <CampHeader />
      ) : partner || school ? (
        <div className="partner_myroom_main partner-wrapper-main">
          {' '}
          <PartnerHeader />{' '}
        </div>
      ) : (
        <CampHeaderGuest />
      )}

      <div className="flex-wrapper accept-challenge">
        <LeftSideBar
          setLeftCollapsse={setLeftCollapsse}
          myInterests={true}
          setShowModal={setShowSignupModal}
        />

        <div
          className={
            'flex-col-center challenge-list-container ' +
            rightCollapsse +
            ' ' +
            leftCollapsse
          }
        >
          <SingleChallengeDetailsWithLoader
            challengeState={challengeState}
            filter={location?.state?.filter}
            tag={location?.state?.selectedTag}
            from={!!location?.state?.from ? location?.state?.from : 'challenge'}
            tabFlag={tabFlag}
            setTabFlag={setTabFlag}
            setChallengeState={setChallengeState}
            onUploadComplete={onUploadComplete}
            acceptedTitle={acceptedTitle}
            acceptedCount={acceptedCount}
            handleToggleAcceptedDependents={handleToggleAcceptedDependents}
            toggleButton={toggleButton}
            toggleAccepted={toggleAccepted}
            completedTitle={completedTitle}
            toggleCompletedView={toggleCompletedView}
            handleToggleView={handleToggleView}
            hasSubmission={hasSubmission}
            noSubmissionView={noSubmissionView}
            completedView={completedView}
            setSubscribedTreehouse={setSubscribedTreehouse}
            subscribedTreehouses={subscribedTreehouses}
            setLoading={setLoading}
            loading={loading}
            setAcceptPrompt={setAcceptPrompt}
            setShowTimeToUpgradePopup={setShowTimeToUpgradePopup}
            getChallengeDetail={getChallengeDetail}
          />
        </div>
        <RightSideBar
          setRightCollapsse={setRightCollapsse}
          isNewChallengesButton={true}
          challenge={challengeState.repos}
          isChatShow={
            challengeState.repos?.challenge_status === 'SELECTED' ? true : false
          }
        />
        {challengeState?.repos?.agora_group_id && (
          <ChatInfoModal showModal={showModal} setShowModal={setShowModal} />
        )}
        <OptimizeSignup
          showModal={showSignupModal}
          setShowModal={setShowSignupModal}
        />
        {showTimeToUpgradePopup && (
          <TimeToUpgradeModal
            showPopup={showTimeToUpgradePopup}
            setShowPopup={setShowTimeToUpgradePopup}
            upgradeType="challenge"
          />
        )}
      </div>
    </div>
  );
};

export default SingleSpecialChallenge;
